<div class="award-history-section" [attr.aria-labelledby]="idPrefix + 'HistoryHeading'" [attr.data-qa]="idPrefix + 'HistorySection'" [attr.data-pw]="idPrefix + 'HistorySection'">
  <div class="award-recipients-section">
    <h3 class="recipients-title">List of Award Recipients</h3>
    <form [formGroup]="awardHistoryForm" class="history-form" [attr.data-qa]="idPrefix + 'HistoryForm'" [attr.data-pw]="idPrefix + 'HistoryForm'">
      <div class="form-labels">
        <label [id]="idPrefix + 'AwardRoundLabel'" [for]="idPrefix + 'AwardRound'" class="form-label">Round</label>
      </div>
      <div class="form-row">
        <!-- Dropdown for Rounds -->
        <mat-form-field appearance="outline" class="history-dropdown" [attr.data-qa]="idPrefix + 'RoundField'" [attr.data-pw]="idPrefix + 'RoundField'">
          <mat-select
            formControlName="round"
            [id]="idPrefix + 'AwardRound'"
            [attr.data-qa]="idPrefix + 'AwardRound_select'"
            [attr.data-pw]="idPrefix + 'AwardRound_select'"
            [attr.aria-labelledby]="idPrefix + 'AwardRoundLabel'">
            <mat-option disabled selected [value]="">Please Select</mat-option>
            @for (round of rounds; track round) {
              <mat-option [value]="round.id">
                {{ round.awardRoundTitle }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Search Button -->
        <button
          mat-raised-button
          class="search-button"
          (click)="onSearch()"
          [disabled]="!awardHistoryForm.valid"
          [id]="idPrefix + 'SearchButton'"
          [attr.data-qa]="idPrefix + 'SearchButton'"
          [attr.data-pw]="idPrefix + 'SearchButton'"
          type="button">
          Search
        </button>
      </div>
      @if (recipients.length > 0) {
        <div class="recipients-section">
          <cfi-mat-table
            aria-label="award recipients list"
            [columnDefinitions]="columnDefinitions"
            [columnsToDisplayWithExpand]="displayedColumns"
            [data]="recipients"
            [displayedColumns]="displayedColumns"
            [sortKey]="sortColumn"
            [totalRows]="totalCount || 0"
            [currentPageIndex]="(currentPage || 1) - 1"
            [currentPageSize]="pageSize || 25"
            [pageSizeOptions]="pageSizeOptions"
            (cbPaginate)="onPageChange($event)"
            (cbSort)="onSortChange($event)">
            <ng-template #headerTemplate let-column>
              <div [attr.aria-label]="column.header">
                {{ column.header }}
              </div>
            </ng-template>
            <ng-template #cellTemplate let-column="column" let-recipient>
              <div class="table-cell">
                @switch (column.name) {
                  @case ('applicationDate') {
                    {{ recipient[column.name] | date: 'MM/dd/yyyy' }}
                  }
                  @case ('awardAmount') {
                    {{ recipient[column.name] | currency }}
                  }
                  @case ('esaFundingLevel') {
                    {{ recipient[column.name] }}
                  }
                  @default {
                    {{ recipient[column.name] }}
                  }
                }
              </div>
            </ng-template>
          </cfi-mat-table>
        </div>
      }
    </form>
  </div>
</div>
